module.exports = "/_next/static/images/c89c2224dad154edf922268fae3cd0f9-slide4mobile.jpg";